import { Extension } from '@tiptap/core'
import ActionButton from '@/notebook/components/ActionButton.vue'
import { useTiptapStore } from '@/notebook/hooks'
import type { GeneralOptions } from '@/notebook/type'

const store = useTiptapStore()

declare module '@tiptap/core' {
  type Commands<ReturnType> = {
    preview: {
      togglePreview: () => ReturnType
    }
  }
}
export type PreviewOptions = {} & GeneralOptions<PreviewOptions>

export const Preview = Extension.create<PreviewOptions>({
  name: 'preview',
  addOptions() {
    return {
      ...this.parent?.(),
      button: ({ t }) => ({
        component: ActionButton,
        componentProps: {
          icon: 'Eye',
          action: () => {
            store.togglePreview()
          },
          tooltip: t('editor.preview.tooltip'),
          isActive: () => store.state.showPreview,
        },
      }),
    }
  },
  addCommands() {
    return {
      togglePreview:
        () =>
        ({ editor }) => {
          store.togglePreview()

          return true
        },
    }
  },
})
